import * as Yup from 'yup';

// import { containsLettersRegExp } from '../../../../utils/regexp/containsLettersRegExp';

export const questionValidationSchema = Yup.object().shape({
    answerDetails: Yup.string().nullable().required('Required'),
    securityQuestion: Yup.string().nullable().required('Required'),
});
